import { RouteComponentProps } from 'react-router-dom';
import { sendEmailResetPassword } from '../../api/constlink';
import ForgotPasswordComponent from '../../components/auth/ForgotPasswordComponent';

function ForgotPasswordContainer({ history }: RouteComponentProps) {
  // const [alertMsg, setAlertMsg] = useState<any>();

  const onFinish = async (formData: any) => {
    const res = await sendEmailResetPassword({ email: formData.email });
    if (res.status === 'SEND_OK') {
      // setAlertMsg({
      //   message: '메일을 전송 하였습니다. 메일함을 확인하세요.',
      //   type: 'info',
      // });
      alert('메일을 전송하였습니다. 메일함을 확인하세요.');
      history.push('/login');
    } else if (res.status === 'ALREADY_SENT') {
      // setAlertMsg({
      //   message: '이미 메일을 전송하였습니다. 메일함을 확인하세요.',
      //   type: 'info',
      // });
      alert('이미 메일을 전송하였습니다. 메일함을 확인하세요.');
      history.push('/login');
    } else if (res.status === 'NOT_EXIST_USER') {
      // setAlertMsg({
      //   message: '존재하지 않는 사용자(이메일) 입니다.',
      //   type: 'error',
      // });
      alert('존재하지 않는 사용자(이메일) 입니다.');
    } else if (res.status === 'SEND_FAIL') {
      // setAlertMsg({ message: '메일 발송 실패 하였습니다.', type: 'error' });
      alert('메일 발송 실패 하였습니다.');
    }
  };

  const onCancel = () => history.goBack();
  return (
    <>
      {/* {alertMsg && (
        <Alert
          message={`${alertMsg.message}`}
          type={
            alertMsg.type === 'error'
              ? 'error'
              : alertMsg.type === 'warning'
              ? 'warning'
              : 'info'
          }
          closable
          style={{ marginTop: '5px', marginBottom: '5px' }}
        />
      )} */}
      <ForgotPasswordComponent onFinish={onFinish} onCancel={onCancel} />
    </>
  );
}

export default ForgotPasswordContainer;
